const { handleError, handleResponse, api } = require("./baseApi");

const api_config = require("./api_config");


function postMerchantFootprintApi(merchantCode, body) {
    return api
        .post(
            `/footprints/v1/business`, body,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: { merchantCode }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function postPersonalFootprint(body) {
  return api
    .post(
      `/footprints/v1/personal`,
        body,
      {
        headers: {
          "x-api-key": `${api_config.carbon_app_api_key}`
        }
      }
    )
    .then(handleResponse)
    .catch(handleError);
}

function getLatestPersonalFootprintByEmail(email) {
    return api
        .get(
            `/footprints/v1/personal/latest`,
            {
                params: {email},
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function updateMerchantFootprintApi(merchantCode, footprintId, body) {
    return api
        .put(
            `/footprints/v1/business/${footprintId}`, body,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: { merchantCode }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function postMerchantFootprintResultsApi(merchantCode, body) {
    return api
        .post(
            `/footprints/v1/business/results`, body,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: {merchantCode}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function updateMerchantFootprintResultsApi(merchantCode,footprintId, body) {
    return api
        .put(
            `/footprints/v1/business/results/${footprintId}`, body,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: { merchantCode }
            }
        )
        .then(handleResponse)
        .catch(handleError);
}


function getMerchantFootprintResultsApi(merchantCode) {
    return api
        .get(
            `/footprints/v1/business/results`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: {merchantCode}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}


function getGroupFootprintsSummary(groupId, locale) {
    return api
        .get(
            `/footprints/v1/groups/${groupId}/summary`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: {locale}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getBusinessFootprintSubscriptionApi(merchantCode) {
    return api
        .get(
            `/subscriptions/v1/footprint`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`,
                 },
                params: {merchantCode}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

function getBusinessGroupSubscriptionApi(merchantCode) {
    return api
        .get(
            `/subscriptions/v1/group`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`,
                },
                params: {merchantCode}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}


module.exports = { getGroupFootprintsSummary, postMerchantFootprintApi, postMerchantFootprintResultsApi, getMerchantFootprintResultsApi, updateMerchantFootprintApi, updateMerchantFootprintResultsApi, postPersonalFootprint, getLatestPersonalFootprintByEmail, getBusinessFootprintSubscriptionApi, getBusinessGroupSubscriptionApi};
